import { Mail, MapPin, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { CONTACT, LOGO_URL } from "../lib/site-data";
import FooterContactForm from "./FooterContactForm";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-foreground text-background mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="bg-white inline-block rounded-md p-2">
            <img
              src={LOGO_URL}
              alt="CV Folks"
              loading="lazy"
              decoding="async"
              width="160"
              height="48"
              className="h-12 w-auto object-contain"
            />
          </div>
          <p className="mt-5 text-background/70 max-w-md leading-relaxed">
            CV Folks is a UK-based professional CV writing service. Our expert
            CV writers offer CV help, cover letter writing, LinkedIn profile
            makeovers and a complete professional CV rewrite service — backed
            by our 60-Day Interview Guarantee.
          </p>

          <h4 className="text-base font-serif font-semibold mt-8 mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-background/80">
            <li className="flex items-start gap-2">
              <Mail className="h-4 w-4 mt-1 text-brand-400" />
              <a
                href={`mailto:${CONTACT.email}`}
                data-testid="footer-email"
                className="hover:text-brand-400"
              >
                {CONTACT.email}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <Phone className="h-4 w-4 mt-1 text-brand-400" />
              <a
                href={`https://wa.me/${CONTACT.whatsappRaw}`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="hover:text-brand-400"
              >
                {CONTACT.whatsapp} (WhatsApp only)
              </a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="h-4 w-4 mt-1 text-brand-400" />
              <span>{CONTACT.address}</span>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-base font-serif font-semibold mb-4">Site map</h4>
          <ul className="space-y-2.5 text-sm text-background/80">
            <li><Link to="/ai-cv-maker-builder" data-testid="footer-nav-ai" className="hover:text-brand-400">AI CV Maker · £9.99</Link></li>
            <li><Link to="/services/cv-writing" data-testid="footer-nav-cv-writing" className="hover:text-brand-400">CV Writing Service</Link></li>
            <li><Link to="/services/linkedin-optimisation" data-testid="footer-nav-linkedin" className="hover:text-brand-400">LinkedIn Optimisation</Link></li>
            <li><Link to="/pricing" data-testid="footer-nav-pricing" className="hover:text-brand-400">Pricing</Link></li>
            <li><Link to="/career-resources" data-testid="footer-nav-resources" className="hover:text-brand-400">Career Resources</Link></li>
            <li><Link to="/about" data-testid="footer-nav-about" className="hover:text-brand-400">About</Link></li>
            <li><Link to="/contact" data-testid="footer-nav-contact" className="hover:text-brand-400">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-5">
          <h4 className="text-base font-serif font-semibold mb-4">
            Contact us
          </h4>
          <FooterContactForm />
        </div>
      </div>
      <div className="border-t border-background/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 text-[11px] text-background/45 leading-relaxed">
          <p data-testid="footer-seo-copy">
            CV Folks · CV writing services · CV writer · professional CV
            writing service · CV help · professional CV rewrite service · get
            your CV professionally written · cover letter writing · LinkedIn
            profile writing — all delivered by UK-based expert CV writers,
            backed by a 60-Day Interview Guarantee.
          </p>
        </div>
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between text-xs text-background/60 gap-2 border-t border-background/10">
          <span>© {new Date().getFullYear()} CV Folks. All rights reserved.</span>
          <span>Made in London — 354 Gray's Inn Rd, WC1X 8BP</span>
        </div>
      </div>
    </footer>
  );
}
